module.exports = __webpack_public_path__ + "img/series_07.1683b370.png";